<div>
  <!-- Loading State -->
  <div *ngIf="loading" class="text-center py-5">
    <div class="spinner-border text-primary" role="status">
      <span class="visually-hidden">Loading activities...</span>
    </div>
  </div>

  <!-- Empty State -->
  <div *ngIf="!loading && activities.length === 0" class="text-center py-5 text-muted">
    <i class="bi bi-clock-history fs-1 d-block mb-3"></i>
    <h5 class="text-muted">No activity recorded yet</h5>
    <p class="text-muted">Activity will appear here as organization members perform actions.</p>
  </div>

  <!-- Activity Feed -->
  <div *ngIf="!loading && activities.length > 0" class="list-group list-group-flush">
    <div
      *ngFor="let activity of activities"
      class="list-group-item bg-transparent px-0 py-3 d-flex align-items-start gap-3"
    >
      <!-- Event Type Icon -->
      <div class="flex-shrink-0">
        <span
          class="badge rounded-circle d-flex align-items-center justify-content-center p-2 fs-6"
          [ngClass]="getEventBadgeClass(activity.eventType)"
        >
          <i class="bi" [ngClass]="getEventIcon(activity.eventType)"></i>
        </span>
      </div>

      <!-- Activity Content -->
      <div class="flex-grow-1 overflow-hidden">
        <div class="d-flex align-items-start justify-content-between gap-2">
          <div>
            <!-- Message -->
            <p class="mb-1">{{ activity.message }}</p>
            <!-- Event type label -->
            <span
              class="badge bg-opacity-10 text-body text-capitalize"
              [ngClass]="getEventBadgeClass(activity.eventType)"
            >
              {{ getEventLabel(activity.eventType) }}
            </span>
          </div>
          <!-- Relative Timestamp -->
          <small class="text-muted text-nowrap flex-shrink-0">
            {{ getRelativeTime(activity.createdAt) }}
          </small>
        </div>
      </div>
    </div>

    <!-- Load More Button -->
    <div *ngIf="hasMore" class="text-center py-3">
      <button
        class="btn btn-outline-primary btn-sm"
        (click)="loadActivities(nextCursor!)"
        [disabled]="loadingMore"
      >
        <span
          *ngIf="loadingMore"
          class="spinner-border spinner-border-sm me-1"
          role="status"
        >
          <span class="visually-hidden">Loading...</span>
        </span>
        {{ loadingMore ? 'Loading...' : 'Load More' }}
      </button>
    </div>
  </div>
</div>
